module.exports = __webpack_public_path__ + "static/media/genii.d2466526.jpeg";